import './header.css';
import Horizontallogo from '../images/Horizontallogo.jpg'
import React, { useState, useEffect  } from 'react';
import { useUserContext } from './UserContext.js';
import LoginSignupModal from './loginsignupmodal.js';
import PageMenu from './pagemenu.js';
import NotificationCenter from './NotificationCenter.js';
import { useNavigate, useLocation } from 'react-router-dom';




const WheelIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="3" />
    <line x1="12" y1="2" x2="12" y2="9" />
    <line x1="12" y1="15" x2="12" y2="22" />
    <line x1="2" y1="12" x2="9" y2="12" />
    <line x1="15" y1="12" x2="22" y2="12" />
    <line x1="4.22" y1="4.22" x2="9.17" y2="9.17" />
    <line x1="14.83" y1="14.83" x2="19.78" y2="19.78" />
    <line x1="19.78" y1="4.22" x2="14.83" y2="9.17" />
    <line x1="9.17" y1="14.83" x2="4.22" y2="19.78" />
  </svg>
);

const Header = () => {
  const { user } = useUserContext();
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const getUserInitials = (user) => {
    // Use the initials field from the user profile if available
    if (user?.initials && user.initials.trim()) {
      return user.initials.toUpperCase();
    }
    
    // Fallback to generating initials from username if no initials field
    const username = user?.username || '';
    if (!username || typeof username !== 'string') return '';
    
    const words = username.trim().split(/\s+/).filter(word => word.length > 0);
    
    if (words.length >= 2) {
      return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
    } else if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }
    
    return username.charAt(0).toUpperCase();
  };
  

  return (
    <div className="header">
        <img className='imgHorizontallogo' src={Horizontallogo} alt='Horizontallogo' />
        
        {/* Desktop PageMenu */}
        <PageMenu className="desktop-pagemenu" />
        
        <nav className="header-nav">
        {user ? (
          <>
            <button
              className={`header-wheel-btn ${location.pathname === '/wheels' ? 'active' : ''}`}
              onClick={() => navigate('/wheels')}
              title="Wheel Library"
              aria-label="Wheel Library"
            >
              <WheelIcon />
            </button>
            <NotificationCenter />
            <button className="header-user-info" onClick={toggleModal}>
              <span className="desktop-username">{user.username}</span>
              <span className="mobile-initials">{getUserInitials(user)}</span>
            </button>
          </>
        ) : (
          <button className="header-login-btn" onClick={toggleModal}>
            Log In
          </button>
        )}
      </nav>
      
      <LoginSignupModal showModal={showModal} toggleModal={toggleModal} />
    </div>
  );
}

export default Header;
